
import { PaperAirplaneIcon, XCircleIcon } from '@heroicons/react/16/solid';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge } from '../../catalyst/badge';
import { Button } from "../../catalyst/button";
import { Checkbox, CheckboxField, CheckboxGroup } from '../../catalyst/checkbox';
import { Divider } from '../../catalyst/divider';
import { Description, Label } from '../../catalyst/fieldset';
import { Heading } from '../../catalyst/heading';
import LoadingMain from '../../components/LoadingMain';
import config from '../../config';


import { Text } from '../../catalyst/text';
import { getIconForTransfer } from '../../utils';
import TidalIcon from '../../assets/tidal_logo_black.png';


export default function Library(props) {


  const [loading, setLoading] = useState(true); // State to track loading state
  const [playlists, setPlaylists] = useState([])
  const [albums, setAlbums] = useState([])
  const [likedCount, setLikedCount] = useState(0)
  const [selectedAccountType, setSelectedAccountType] = useState('')
  const [selectedPlaylists, setSelectedPlaylists] = useState({})
  const [selectedAlbums, setSelectedAlbums] = useState({})
  const [isLikedSelected, setLikedSelected] = useState(false)
  const [playlistsExpanded, setPlayListsExpanded] = useState(false)
  const [showTagetList, setShowTargetList] = useState(false)
  const navigate = useNavigate();

  const [playlistAccordionOpen, setPlaylistAccordionOpen] = React.useState(false);

  const [albumAccordionOpen, setAlbumAccordionOpen] = React.useState(false);

  const [isBetaUser, setBetaUser] = useState(JSON.parse(localStorage.getItem('user')).beta)

  const [totalConnectedAccounts, setTotalConnectedAccounts] = useState(props.connectedAccounts === null ? 0 : props.connectedAccounts.length)


  useEffect(() => {
    if (props.selectedAccount === '') {
      return
    }
    const fetchData = async () => {
      try {
        setLoading(true); // Set loading state to true
        const response = await fetch(config.apiUrl + "/connectedAccount/" + props.selectedAccount + "/playlists", {
          headers: {
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
          }
        });

        const status = await response.status;
        if (status === 200) {
          let data = await response.json()
          setPlaylists(data["userPlaylistList"])
          setAlbums(data["userAlbums"])
          setLikedCount(data["likedSongsCount"])
          setSelectedAccountType(data["accountType"])
        } else {
          throw new Error('Failed to get playlists');
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // Set loading state to false after fetch completes
      }
    };
    fetchData(); // Call fetchData function when component mounts
  }, [props.selectedAccount]); // Empty dependency array ensures useEffect runs only once




  function disconnectAccountAndRefresh(id) {

    //TODO: rewrite this shit and other fetch like this
    try {
      // Make PUT request with ID
      fetch(config.apiUrl + '/connectedAccount/' + id + '/disconnect', {
        method: 'PUT',
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
          // Add any necessary headers like authorization tokens here
        },
        // Add any request body if required
        body: JSON.stringify({}),
      })
        .then(response => {
          if (!response.ok) {
            navigate(config.accountsPath + '?message=FAILED_TO_DISCONNECT')
          }
          return response.text();
        })
        .then(data => {
          window.location.href = config.accountsPath;
        })
        .catch(error => {
          navigate(config.accountsPath + '?message=FAILED_TO_DISCONNECT')
        });


    }
    catch (error) {
      console.error('Error connecting Apple music:', error);
    }
  }

  function isAnyPlayListSelected() {
    for (let i = 0; i < playlists.length; i++) {
      if (selectedPlaylists[playlists[i].id] != undefined && selectedPlaylists[playlists[i].id] === true) {
        return true;
      }
    }
    return false;
  }


  //playlist function

  const handlePlaylistSelectAllChange = (checked) => {

    let bkpPl = { ...selectedPlaylists };
    playlists.map((playlist) => {
      bkpPl[playlist.id] = checked
    })


    setSelectedPlaylists(bkpPl)
  }

  function isPlaylistIndeterminate() {
    let hasTrue = false
    let hasFalse = false;
    playlists.map((playlist) => {
      if (selectedPlaylists[playlist.id] === undefined || selectedPlaylists[playlist.id] === false) {
        hasFalse = true
      }
      if (selectedPlaylists[playlist.id] === true) {
        hasTrue = true
      }
    })
    return hasFalse && hasTrue
  }


  function isPlayListSelected(id) {
    if (selectedPlaylists[id] === true) {
      return true
    }
    return false;
  }

  const handlePlaylistSelection = (key) => {

    let bkpPl = { ...selectedPlaylists };
    if (bkpPl[key] === undefined || selectedPlaylists[key] === false) {
      bkpPl[key] = true
    } else {
      bkpPl[key] = false
    }
    setSelectedPlaylists(bkpPl)
  }



  //albums function

  function isAllAlbumSelected() {
    let isAllSelected = true
    albums.map((album) => {
      if (selectedAlbums[album.id] === undefined || selectedAlbums[album.id] === false) {
        isAllSelected = false
      }
    })
    return isAllSelected;
  }



  const handleAlbumSelectAllChange = (checked) => {

    let bkpPl = { ...selectedAlbums };
    albums.map((album) => {
      bkpPl[album.id] = checked
    })


    setSelectedAlbums(bkpPl)
  }

  function isAlbumIndeterminate() {
    let hasTrue = false
    let hasFalse = false;
    albums.map((album) => {
      if (selectedAlbums[album.id] === undefined || selectedAlbums[album.id] === false) {
        hasFalse = true
      }
      if (selectedAlbums[album.id] === true) {
        hasTrue = true
      }
    })

    return hasFalse && hasTrue
  }


  function isAlbumSelected(id) {
    if (selectedAlbums[id] === true) {
      return true
    }
    return false;
  }

  const handleAlbumSelection = (key) => {

    let bkpPl = { ...selectedAlbums };
    if (bkpPl[key] === undefined || selectedAlbums[key] === false) {
      bkpPl[key] = true
    } else {
      bkpPl[key] = false
    }
    setSelectedAlbums(bkpPl)
  }


  function isAnySelected() {
    if (isLikedSelected) {
      return true;
    }
    if (Object.values(selectedPlaylists).some(value => value === true)) {
      return true;
    }
    if (Object.values(selectedAlbums).some(value => value === true)) {
      return true;
    }
  }

  function disableTransferOption() {
    let val = (!isAnySelected() || props.connectedAccounts.length < 2)
    return val
  }

  function selectedAlbumSize() {
    let count = 0;
    Object.keys(selectedAlbums).map(function (keyName, keyIndex) {
      // use keyName to get current key's name
      // and a[keyName] to get its value
      if (selectedAlbums[keyName] === true) {
        count++
      }
    });
    return count
  }


  function selectedPlaylistSize() {
    let count = 0;
    Object.keys(selectedPlaylists).map(function (keyName, keyIndex) {
      // use keyName to get current key's name
      // and a[keyName] to get its value
      if (selectedPlaylists[keyName] === true) {
        count++
      }
    });
    return count
  }

  function Menu() {
    return (<div>

      <div className="flex justify-start p-2">

        <Button onClick={() => { disconnectAccountAndRefresh(props.selectedAccount) }} className="cursor-pointer" outline>
          <XCircleIcon /> Disconnect
        </Button>
      </div>

      <div className="flex justify-end p-2">

        {/* TODO disable on only one account connected */}
        <div className="flex space-x-2">
          <Button className="cursor-pointer" disabled={disableTransferOption()} onClick={() => { props.setTransferData(getTransferData("automatic")); props.setShowTransferTargetMenu(true); }}>
            Start Transfer <PaperAirplaneIcon />
          </Button>
          {isBetaUser ? <><Button className="cursor-pointer" disabled={disableTransferOption()} onClick={() => { props.setTransferData(getTransferData("manual")); props.setShowTransferTargetMenu(true); }}>
            Verify and Transfer <PaperAirplaneIcon />
          </Button></> : <></>}
        </div>
      </div>

      {totalConnectedAccounts === 1 ? <Badge color="red" className="m-2">Connect atleast 2 accounts to start transfer.</Badge> : <></>}

      <div>

        <div
          className={isLikedSelected ? "" : ""}
        >
          <CheckboxGroup>
            <CheckboxField className="min-h-[80px] flex items-center">
              <div onClick={() => setLikedSelected(!isLikedSelected)} className="flex items-center">
                <Checkbox
                  checked={isLikedSelected}
                  onClick={() => setLikedSelected(!isLikedSelected)}
                  disabled={likedCount === 0} />
              </div>
              <div className="ml-3">
               <Label> <Heading>{likedCount + " saved/liked tracks"} </Heading></Label>
                <Description>Your saved/liked tracks.</Description>
              </div>
            </CheckboxField>
          </CheckboxGroup>

        </div>

      


        <div className="mt-7">

          <CheckboxField>

            <Checkbox
              checked={isAnyPlayListSelected() && playlists.length != 0}
              indeterminate={isPlaylistIndeterminate()}
              onChange={(checked) => handlePlaylistSelectAllChange(checked)}
              disabled={playlists.length === 0}
            />
            <div className="ml-3">
              <Label><Heading>{selectedPlaylistSize() + "/" + playlists.length + " Playlists Selected"}</Heading></Label>
            </div>
          </CheckboxField>

          <div className="flex flex-col ml-1">
            {

              playlists.map((playlist) => (
                <div key={playlist.id} className={isPlayListSelected(playlist.id) ? "pt-4" : "pt-4"}>
                  <div className="flex items-center justify-between">

                    <CheckboxField key={playlist.id} className="flex items-center">
                      <Checkbox checked={isPlayListSelected(playlist.id)} onChange={() => handlePlaylistSelection(playlist.id)} />
                      <div className="ml-3">
                        <Label>{getPlaylistTitleForView(playlist)}</Label>
                      </div>
                    </CheckboxField>
                    <div className="flex items-center gap-4">
{/* 
                      <Dropdown>
                        <DropdownButton plain aria-label="More options">
                          <EllipsisVerticalIcon />
                        </DropdownButton>
                        <DropdownMenu anchor="bottom end">
                          <DropdownItem href={"event.url"}>View</DropdownItem>
                          <DropdownItem>Edit</DropdownItem>
                          <DropdownItem>Delete</DropdownItem>
                        </DropdownMenu>
                      </Dropdown> */}
                    </div>
                  </div>

                  <Divider className="mt-4" />
                </div>

              ))
            }
          </div>
        </div>


        <div className="mt-7">
          <>{selectedAccountType === "youtube" ? <><Badge color='red' className="m-2">Album transfer not supported for youtube.</Badge></> : <></>}</>


          <CheckboxField className="flex items-center">
            <Checkbox
              checked={isAnyAlbumSelected() && albums.length != 0}
              indeterminate={isAlbumIndeterminate()}
              onChange={(checked) => handleAlbumSelectAllChange(checked)}
              disabled={albums.length === 0}
            ></Checkbox>
            <div className="ml-3">
              <Label><Heading>{selectedAlbumSize() + "/" + albums.length + " Albums Selected"}</Heading></Label>
            </div>
          </CheckboxField>


          <div className="flex flex-col ml-3">
            {
              albums.map((album) => (
                <div key={album.id} className={isAlbumSelected(album.id) ? "pt-4" : "pt-4"}>
                  
                  <div className="flex items-center justify-between">

                  <CheckboxField key={album.id} className="flex items-center">
                    <Checkbox checked={isAlbumSelected(album.id)} onChange={() => handleAlbumSelection(album.id)} />
                    <div className="ml-3">
                      <Label>{getAlbumTitleForView(album)}</Label>
                    </div>
                  </CheckboxField>
                  <div className="flex items-center gap-4">
{/* 
                <Dropdown>
                  <DropdownButton plain aria-label="More options">
                    <EllipsisVerticalIcon />
                  </DropdownButton>
                  <DropdownMenu anchor="bottom end">
                    <DropdownItem href={"event.url"}>View</DropdownItem>
                    <DropdownItem>Delete</DropdownItem>
                  </DropdownMenu>
                </Dropdown> */}
                </div>
                </div>
                  <Divider className="mt-4" />
                </div>
              ))
            }
          </div>


        </div>

      </div>

    </div>)
  }

  function getPlaylistTitleForView(playlist) {
    let thumbnail = ""
    if (selectedAccountType === 'appleMusic' && playlist.thumbnailUrl != null) {
      thumbnail = playlist.thumbnailUrl.replace("{w}", 128)
      thumbnail = thumbnail.replace("{h}", 85)
    }


    return (
      <>
        <div key={playlist.id} className="flex gap-6 py-6">
          <div className="w-32 shrink-0">
            <img className="aspect-3/2 rounded-lg shadow-sm" src={selectedAccountType === 'appleMusic' ? thumbnail : playlist.thumbnailUrl} alt="" />
          </div>
          <div className="space-y-1.5">
            <div className="text-base/6 font-semibold">
              <Text>{playlist.title}</Text>
            </div>
            <div className="text-xs/6 text-zinc-500">
              <span aria-hidden="true">{selectedAccountType === 'appleMusic' ? "" : playlist.itemsCount + " tracks"}</span>
            </div>
          </div>
        </div>
      </>

    )

  }

  function getAlbumTitleForView(album) {
    let thumbnail = ""
    if (selectedAccountType === 'appleMusic' && album.thumbnailUrl != null) {
      thumbnail = album.thumbnailUrl.replace("{w}", 128)
      thumbnail = thumbnail.replace("{h}", 85)
    } 

    return (
      <>
      <div key={album.id} className="flex gap-6 py-6">
        <div className="w-32 shrink-0">
          {selectedAccountType === 'tidal' ? <img className="" src={TidalIcon} alt="" /> : <img className="aspect-3/2 rounded-lg shadow-sm" src={selectedAccountType === 'appleMusic' ? thumbnail : album.thumbnailUrl} alt="" />}
        </div>
        <div className="space-y-1.5">
          <div className="text-base/6 font-semibold">
            <Text>{album.title}</Text>
          </div>
          <div className="text-xs/6 text-zinc-500">
            <span aria-hidden="true">{selectedAccountType === 'appleMusic' ? "" : album.itemsCount + " tracks"}</span>
          </div>
        </div>
      </div>
    </>
    )

  }

  const getPlaylistName = (id) => {
    return playlists.find(playlist => playlist.id === id).title
  }

  const isAnyAlbumSelected = () => {
    let count = 0
    Object.keys(selectedAlbums).map(function (keyName, keyIndex) {
      if (selectedAlbums[keyName] === true) {
        count++;
      }
    })

    if (count > 0) {
      return true
    }
    return false
  }

  function getTransferData(transferMethod) {
    let createRequest = [];

    Object.keys(selectedPlaylists).map(function (keyName, keyIndex) {
      // use keyName to get current key's name
      // and a[keyName] to get its value
      if (selectedPlaylists[keyName] === true) {
        createRequest.push(
          {
            "transferMethod": transferMethod,
            "sourceCaId": props.selectedAccount,
            "sourcePlaylistId": keyName,
            "destinationPlaylistId": "string",
            "sourcePlaylistType": "playlist",
            "destinationPlaylistType": "playlist",//TODO: handle playlist type
            "playlistName": getPlaylistName(keyName),
            "songsIdToExclude": [

            ]
          }
        )
      }
    });

    if (isAnyAlbumSelected()) {
      var ids = []
      Object.keys(selectedAlbums).map(function (keyName, keyIndex) {
        // use keyName to get current key's name
        // and a[keyName] to get its value
        if (selectedAlbums[keyName] === true) {
          ids.push(keyName)
        }
      });

      createRequest.push(
        {
          "transferMethod": transferMethod,
          "sourceCaId": props.selectedAccount,
          "sourcePlaylistId": ids.join(","),
          "destinationPlaylistId": "",
          "sourcePlaylistType": "album",
          "destinationPlaylistType": "album",//TODO: handle playlist type
          "playlistName": "",
          "songsIdToExclude": [

          ]
        }
      )
    }

    if (isLikedSelected) {
      createRequest.push(
        {
          "transferMethod": transferMethod,
          "sourceCaId": props.selectedAccount,
          "sourcePlaylistId": "",
          "destinationPlaylistId": "",
          "sourcePlaylistType": "liked",
          "destinationPlaylistType": "liked",//TODO: handle playlist type
          "playlistName": "",
          "songsIdToExclude": [

          ]
        }
      )
    }
    return createRequest
  }


  return (

    <>
      {
        props.selectedAccount === '' ? <></> :
          loading ? <><LoadingMain /></> : <Menu></Menu>}
    </>


  );
}
